














































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class EYFSEditor extends Vue {
  @Prop({ default: () => [] }) private gradings!: Array<any>
  private type = ''
  private levelAVisible = false
  private levelBVisible = false
  private levelAForm = {
    gradeClassId: 0,
    abbreviation: null,
    name: null,
  }
  private levelBForm = {
    gradeClassId: 0,
    abbreviation: null,
    name: null,
    emerging1Id: 0,
    emerging1: null,
    emerging2Id: 0,
    emerging2: null,
    emerging3Id: 0,
    emerging3: null,
    performing4Id: 0,
    performing4: null,
    performing5Id: 0,
    performing5: null,
    performing6Id: 0,
    performing6: null,
    mastering7Id: 0,
    mastering7: null,
    mastering8Id: 0,
    mastering8: null,
    mastering9Id: 0,
    mastering9: null,
  }
  private parentNumber = ''

  private get levelARules(): any {
    return {
      abbreviation: [
        {
          required: true,
          message: this.$tc('assessmentFrame.noAbbreviation'),
          trigger: 'change',
        },
        {
          max: 50,
          message: this.$tc('assessmentFrame.abbreviationLimit'),
          trigger: 'change',
        },
      ],
      name: [
        {
          required: true,
          message: this.$tc('assessmentFrame.noLevelASkill'),
          trigger: 'change',
        },
        {
          max: 1000,
          message: this.$tc('assessmentFrame.textLimit'),
          trigger: 'change',
        },
      ],
    }
  }

  private get levelBRules(): any {
    return {
      abbreviation: [
        {
          required: true,
          message: this.$tc('assessmentFrame.noAbbreviation'),
          trigger: 'change',
        },
        {
          max: 50,
          message: this.$tc('assessmentFrame.abbreviationLimit'),
          trigger: 'change',
        },
      ],
      name: [
        {
          required: true,
          message: this.$tc('assessmentFrame.noLevelBSkill'),
          trigger: 'change',
        },
        {
          max: 1000,
          message: this.$tc('assessmentFrame.textLimit'),
          trigger: 'change',
        },
      ],
    }
  }

  private addLevelA(): void {
    this.type = 'add'
    this.levelAVisible = true
  }

  private addLevelB(parentNumber): void {
    this.parentNumber = parentNumber
    this.type = 'add'
    this.levelBVisible = true
  }

  private editLevelA(item): void {
    this.type = 'edit'
    this.levelAForm = {
      abbreviation: item.abbreviation,
      name: item.name,
      gradeClassId: item.gradeClassId,
    }
    this.levelAVisible = true
  }

  private editLevelB(item): void {
    this.type = 'edit'
    this.levelBForm = {
      abbreviation: item.abbreviation,
      name: item.name,
      gradeClassId: item.gradeClassId,
      emerging1Id: item.gradingStandards[1].gradeLevelId,
      emerging1: item.gradingStandards[1].description,
      emerging2Id: item.gradingStandards[2].gradeLevelId,
      emerging2: item.gradingStandards[2].description,
      emerging3Id: item.gradingStandards[3].gradeLevelId,
      emerging3: item.gradingStandards[3].description,
      performing4Id: item.gradingStandards[4].gradeLevelId,
      performing4: item.gradingStandards[4].description,
      performing5Id: item.gradingStandards[5].gradeLevelId,
      performing5: item.gradingStandards[5].description,
      performing6Id: item.gradingStandards[6].gradeLevelId,
      performing6: item.gradingStandards[6].description,
      mastering7Id: item.gradingStandards[7].gradeLevelId,
      mastering7: item.gradingStandards[7].description,
      mastering8Id: item.gradingStandards[8].gradeLevelId,
      mastering8: item.gradingStandards[8].description,
      mastering9Id: item.gradingStandards[9].gradeLevelId,
      mastering9: item.gradingStandards[9].description,
    }
    this.levelBVisible = true
  }

  private removeLevelA(gradeClassId): void {
    this.$emit('removeLevelA', gradeClassId)
  }

  private removeLevelB(gradeClassId): void {
    this.$emit('removeLevelB', gradeClassId)
  }

  private resetLevelA(): void {
    this.levelAVisible = false
    this.levelAForm = {
      gradeClassId: 0,
      abbreviation: null,
      name: null,
    }
  }

  private resetLevelB(): void {
    this.parentNumber = ''
    this.levelBVisible = false
    this.levelBForm = {
      gradeClassId: 0,
      abbreviation: null,
      name: null,
      emerging1Id: 0,
      emerging1: null,
      emerging2Id: 0,
      emerging2: null,
      emerging3Id: 0,
      emerging3: null,
      performing4Id: 0,
      performing4: null,
      performing5Id: 0,
      performing5: null,
      performing6Id: 0,
      performing6: null,
      mastering7Id: 0,
      mastering7: null,
      mastering8Id: 0,
      mastering8: null,
      mastering9Id: 0,
      mastering9: null,
    }
  }

  private saveLevelA(): any {
    const levelAForm = this.$refs.levelAForm as any
    levelAForm.validate(valid => {
      if (valid) {
        this.levelAVisible = false
        if (this.type === 'add') {
          this.$emit('saveLevelA', { ...this.levelAForm })
        } else {
          this.$emit('updateLevelA', { ...this.levelAForm })
        }
        this.levelAForm = {
          gradeClassId: 0,
          abbreviation: null,
          name: null,
        }
      } else {
        return false
      }
    })
  }

  private saveLevelB(): any {
    const levelBForm = this.$refs.levelBForm as any
    levelBForm.validate(valid => {
      if (valid) {
        this.levelBVisible = false
        if (this.type === 'add') {
          this.$emit('saveLevelB', {
            parentNumber: this.parentNumber,
            levelB: { ...this.levelBForm },
          })
        } else {
          this.$emit('updateLevelB', { ...this.levelBForm })
        }
        this.levelBForm = {
          gradeClassId: 0,
          abbreviation: null,
          name: null,
          emerging1Id: 0,
          emerging1: null,
          emerging2Id: 0,
          emerging2: null,
          emerging3Id: 0,
          emerging3: null,
          performing4Id: 0,
          performing4: null,
          performing5Id: 0,
          performing5: null,
          performing6Id: 0,
          performing6: null,
          mastering7Id: 0,
          mastering7: null,
          mastering8Id: 0,
          mastering8: null,
          mastering9Id: 0,
          mastering9: null,
        }
      } else {
        return false
      }
    })
  }
}
